// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2fHvD","requiredAsterisk":"Info_requiredAsterisk__3rH9E"};